import React, {useState, useLayoutEffect, useEffect} from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import { Spin } from 'antd';
import Instagram from '../assets/Instagram'
import Facebook from '../assets/Facebook'
import Tiktok from '../assets/Tiktok'
import Logo from "../assets/mainlogo.png";
import Map from "../assets/Icon-1.png";
import Calendar from "../assets/Icon-2.png";
import Smiley from "../assets/Icon-3.png";
import Notification from "../assets/Icon-4.png";
import Sparks from "../assets/Icon-5.png";
import middle from "../assets/blog-middle.jpg"
import MobileTop from "../assets/blog-top-mobile.png"
import Service1 from "../assets/services-01.png"
import Service2 from "../assets/services-02.png"
import Service3 from "../assets/services-03.png"
import Service4 from "../assets/services-04.png"
import Service5 from "../assets/services-05.png"
import Service6 from "../assets/services-06.png"
import Service7 from "../assets/services-07.png"
import Service8 from "../assets/services-08.png"
import TagManager from "react-gtm-module";

const gtmId = "GTM-T4QRDGLB";
const initializeTagManager = () => {
  TagManager.initialize({ gtmId });
};


pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

  const contentStyle = {
    padding: 50,
    background: 'rgba(0, 0, 0, 0)',
    borderRadius: 4,
    color: '#008a80'
  };


const Blog = () => {
    // const [file, setFile] = useState('./thebookerblog.pdf');
    const [loading, setLoading] = useState(false);
    // const [width, setWidth] = useState(window.innerWidth);
    // const [width, height] = useWindowSize();
    // console.log({width})

    // useEffect(() => {
    //     function updateSize() {
    //       setWidth(window.innerWidth);
    //     };
    //     window.addEventListener('resize', updateSize);
    //     return () => window.removeEventListener('resize', updateSize);
    //   }, []);

    useEffect(() => {
      initializeTagManager();
    },[])

  return (
    <>
      {loading && (
        <div
          style={{
            height: "100vh",
            width: "100vw",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin
            size="large"
            spinning={true}
            tip="Loading"
            style={{ color: "#008a80" }}
          >
            <div style={contentStyle} />
          </Spin>
        </div>
      )}

      {/* <div style={{display: loading ? 'none' : 'block', overflow: 'hidden'}}> */}

      {/* <Document file={file}>
            <Page 
                key={'page1'}
                onRenderSuccess={() => setLoading(false)}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                customTextRenderer={false}
                pageNumber={1}
                width={width}
                
            />
       </Document> */}

      <div className="navbar-blog">
        <div className="nav-logo-div">
          <img alt="TheBooker Logo" src={Logo} />
        </div>
      </div>

      <div className="blog-top-img column flex-center">
        <img
          src={MobileTop}
          style={{ maxWidth: "100%", height: "auto" }}
          alt=""
        />
      </div>

      <div className="blog-intro-bg">
        <div className="blog-intro">
          <div>
            <h1>
              Embracing
              <br />
              Personal Care
              <br />
              Together
            </h1>
            <p className="light-text blog-intro-p">
              <span className="p-bold">TheBooker</span> - May 9, 2024
            </p>
          </div>
        </div>

        <div>
          <p className="blog-intro-p">
            Welcome to our corner of the internet! We’re excited to go on this
            journey with you as we dive into the world of personal care, beauty,
            and wellness. At TheBooker, we believe that personal care is not a
            luxury only for special occasions, but a necessity that is unique to
            each one of us and must be integrated seamlessly in our life to be a
            pleasant experience we look forward to.
            <br />
            <br />
            At TheBooker, our mission is to be the leading force in transforming
            the personal care industry by offering a comprehensive platform that
            seamlessly integrates appointment management and marketing tools,
            empowering personal care professionals to thrive and enhancing the
            overall experience for clients.
          </p>
        </div>
      </div>

      <div className="blog-body">
        <div className="blog-faq">
          <h1>What is TheBooker?</h1>
        </div>
        <div>
          <p className="blog-icons-p">
            TheBooker is an app that connects users with personal-care service
            providers through a state of the art discovery and booking system.
            Here is a simplified explanation:
            <br />
            <br />
            1. Through TheBooker, you can search for the service category that
            you need and choose your service provider from our list of trusted
            partners.
            <br />
            <br />
            2. After selecting your desired service provider, you can choose
            your ideal appointment date and time from the available options
            displayed on the calendar in front of you in real time.
            <br />
            <br />
            3. Following your selection of appointment’s date and time, you
            reserve your spot. Then TheBooker makes sure that you receive
            reminders of your appointment, and that your service provider
            expects you at their business to offer you the booked service.
          </p>
        </div>

        <div className="blog-container">
          <div className="blog-q2">
            <img src={middle} alt="" />
          </div>
          <div className="blog-content">
            <h1>TheBooker's Features and Benefits</h1>
            <div className="blog-section1-p blog-icons-p">
              <ul style={{ listStyleType: "none" }}>
                <li>
                  <div className="list-div">
                    <img
                      src={Map}
                      style={{ objectFit: "contain", width: 30, height: 30 }}
                      alt=""
                    />
                    <p>
                      Explore services and discover new service providers
                      <br />
                      <br />
                    </p>
                  </div>
                </li>
                <li>
                  <div className="list-div">
                    <img
                      src={Calendar}
                      style={{ objectFit: "contain", width: 30, height: 30 }}
                      alt=""
                    />
                    <p>
                      See availability live from the app
                      <br />
                      <br />
                    </p>
                  </div>
                </li>
                <li>
                  <div
                    className="list-div"
                    style={{ alignItems: "flex-start" }}
                  >
                    <img
                      src={Smiley}
                      style={{ objectFit: "contain", width: 30, height: 30 }}
                      alt=""
                    />
                    <p>
                      24/7 booking and at your convenience from the app without
                      calling or using third party messaging tools
                      <br />
                      <br />
                    </p>
                  </div>
                </li>
                <li>
                  <div className="list-div">
                    <img
                      src={Notification}
                      style={{ objectFit: "contain", width: 30, height: 30 }}
                    />
                    <p>
                      Get reminded of your appointment to stay on top of your
                      schedule
                      <br />
                      <br />
                    </p>
                  </div>
                </li>
                <li>
                  <div className="list-div">
                    <img
                      src={Sparks}
                      style={{ objectFit: "contain", width: 30, height: 30 }}
                      alt=""
                    />
                    <p>
                      Get unique benefits and deals
                      <br />
                      <br />
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="blog-faq">
          <h1>Where can I access TheBooker?</h1>
        </div>
        <div>
          <p className="blog-p">
            We’ve spent the last months tirelessly working on our product behind
            the scenes. We’re now in our final stages before launching TheBooker
            app. And we cannot wait to reveal the result to you very soon!
          </p>
        </div>

        <div className="blog-faq">
          <h1>TheBooker Blog</h1>
        </div>
        <div>
          <p className="blog-p">
            As part of our mission to positively transform the personal care
            industry, we hope to give you value through our blog. So stay tuned,
            this is the beginning of something big!
            <br />
            Follow us on our social media to stay updated on our progress as we
            approach our launching
          </p>
        </div>

        <div className="blog-faq">
          <h1>Our Services</h1>
        </div>
        <div>
          <div className="image-container row flex-centr">
            <img src={Service1} alt="Service 01" loading="lazy" />
            <img src={Service2} alt="Service 02" loading="lazy" />
            <img src={Service3} alt="Service 03" loading="lazy" />
            <img src={Service4} alt="Service 04" loading="lazy" />
            <img src={Service5} alt="Service 05" loading="lazy" />
            <img src={Service6} alt="Service 06" loading="lazy" />
            <img src={Service7} alt="Service 07" loading="lazy" />
            <img src={Service8} alt="Service 08" loading="lazy" />
          </div>
        </div>

        <div className="blog-footer">
          <div>
            <a
              href="https://www.instagram.com/thebookerapp?igsh=OWEwYXg5YjQ0NXQx"
              target="_blank"
            >
              <Instagram width={30} height={30} />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61558283653706"
              target="_blank"
            >
              <Facebook width={30} height={30} />
            </a>
            <a
              href="https://www.tiktok.com/@thebooker.app?_t=8laJs404Hl2&_r=1"
              target="_blank"
            >
              <Tiktok width={30} height={30} />
            </a>
          </div>
          <div>
            <p>TheBooker App. All Rights Reserved.</p>
          </div>
        </div>
      </div>

      {/* </div> */}
    </>
  );
}

export default Blog